import {
  IBlogReducerState,
  IBlogReducerStateData,
  IBlogReducerStatePageData,
} from '../../interfaces/IBlogReducer';

const initialState: IBlogReducerState = {
  isLoading: false,
  data: {},
  error: '',
  pageData: {},
};

export type TBlogReducerAction =
  | { type: 'request' }
  | {
      type: 'success';
      data: IBlogReducerStateData;
      pageData: IBlogReducerStatePageData;
    }
  | {
      type: 'reset-search';
    }
  | { type: 'failure'; error: string };

function blogReducer(
  state: IBlogReducerState = initialState,
  action: TBlogReducerAction,
): IBlogReducerState {
  switch (action.type) {
    case 'request':
      return { ...state, isLoading: true };
    case 'success':
      return {
        ...state,
        isLoading: false,
        data: action.data,
        pageData: action.pageData,
      };
    case 'reset-search':
      /* eslint-disable no-param-reassign */
      delete state.data?.Search;
      /* eslint-disable no-param-reassign */
      delete state.pageData?.Search;
      return state;
    case 'failure':
      return { ...state, isLoading: false, error: action.error };
    default:
      return initialState;
  }
}

export default blogReducer;
